import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Button,
  Box,
  Typography,
  Modal,
  Backdrop,
  Fade,
} from "@material-ui/core";
import axios from "axios";
import CircularLoader from "src/component/CircularLoader";
import { WebURL } from "src/ApiConfig/ApiConfig";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "transparent",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    width: "30%",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    "@media(max-width:514px)": {
      width: "60%",
    },
  },
  blockButton: {
    background: "#8080805e",
    width: "70%",
    color: "#333",
    marginTop: "12px",
    padding: "10px",
    borderRadius: "50px",
  },
  blockButton1: {
    background: "#017c6b",
    width: "70%",
    color: "#fff",
    marginTop: "12px",
    padding: "10px",
    borderRadius: "50px",
    "&:hover": {
      background: "#017c6b",
    },
  },
}));

const ServerModal = ({ showPosition }) => {
  const classes = useStyles();
  const [locAllowOpen, setLocAllowOpen] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const googleMapKey = "AIzaSyCzU4XQ6D43-mEnHWZ5l3vobePxE6p2GRw"; // Replace with your actual API key

  // Centralized Axios Configuration
  const axiosInstance = axios.create({
    baseURL: "https://www.googleapis.com",
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Function to call API with retry logic
  const callApiWithRetry = async (url, options, retries = 3) => {
    try {
      const response = await axiosInstance.post(url, options);
      return response;
    } catch (err) {
      if (err.response?.status === 401) {
        // Handle 401 error (e.g., redirect to login or notify the user)
        setError("Unauthorized. Please check your permissions.");
        throw err;
      } else if (retries > 0) {
        return callApiWithRetry(url, options, retries - 1);
      } else {
        setError("Failed to fetch location data. Please try again later.");
        throw err;
      }
    }
  };

  // Function to get user's location
  const getData = async () => {
    setLoading(true);
    setError(null); // Reset error before API call
    try {
      const response = await callApiWithRetry(
        `/geolocation/v1/geolocate?key=${googleMapKey}`
      );
      const position = {
        coords: {
          latitude: response.data.location.lat,
          longitude: response.data.location.lng,
        },
      };
      await showPosition(position);
      setLocAllowOpen(false);
    } catch (err) {
      console.error("Error fetching location data:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={locAllowOpen}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={locAllowOpen}>
          <div className={classes.paper}>
            <Typography
              style={{ color: "#017c6b", fontSize: "24px", fontWeight: "600" }}
              id="server-modal-title"
            >
              Kanabix
            </Typography>
            <Typography
              style={{ color: "#017c6b", fontSize: "16px", fontWeight: "600" }}
            >
              {WebURL} says
            </Typography>
            <Typography
              style={{ color: "black", fontSize: "14px", fontWeight: "600" }}
              id="server-modal-description"
            >
              You need to enable geolocation services in your browser to use
              this feature.
            </Typography>
            {error && (
              <Typography
                style={{ color: "red", fontSize: "12px", marginTop: "10px" }}
              >
                {error}
              </Typography>
            )}
            <Box display="flex" justifyContent="space-between">
              <Button
                className={classes.blockButton}
                onClick={() => setLocAllowOpen(false)}
              >
                Block
              </Button>
              <Button
                className={classes.blockButton1}
                onClick={getData}
                disabled={isLoading}
              >
                {isLoading ? <CircularLoader /> : "Ok"}
              </Button>
            </Box>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

export default ServerModal;
